import { type CellContext } from '@tanstack/react-table';
import { type FC } from 'react';

import { type WithValueChildren } from './types';

const withCellValue = (WrappedComponent: FC<WithValueChildren>) => {
  const ComponentWithCellValue = <TData,>({
    getValue,
  }: CellContext<TData, unknown>) => {
    return <WrappedComponent>{getValue() as string}</WrappedComponent>;
  };

  return ComponentWithCellValue;
};

export { withCellValue };
